/**
 * BAMKO official brand logo (uses uploaded PNG assets — do NOT recreate).
 *
 * Two variants:
 *   <BrandLogo />           – full BAMKO wordmark lockup with "Trusted by India's Families" pill
 *   <BrandLogo mark />      – square red round-B monogram mark only
 *
 * Props: `size` (px height, default 32), `className`, `alt`.
 * (`tagline` and `mono` are accepted for backwards-compat but no-op — the
 *  official lockup PNG already carries the tagline.)
 */
export function BrandLogo({
  size = 32,
  mark = false,
  className = "",
  alt = "BAMKO",
  // Accepted for backwards-compat but no-op (uploaded PNG already carries tagline)
  tagline: _tagline = false, mono: _mono = false,
}) {
  const src = mark ? "/brand/babu-mark.png" : "/brand/babu-lockup.png";
  // Intrinsic aspect ratios of the source PNGs
  //   mark   → 1:1
  //   lockup → ~3.3:1 (wordmark + tagline)
  const width = mark ? size : Math.round(size * 3.3);

  return (
    <img
      src={src}
      alt={alt}
      height={size}
      width={width}
      style={{ height: size, width: mark ? size : "auto", display: "block", flexShrink: 0 }}
      className={className}
      draggable={false}
    />
  );
}

export default BrandLogo;
